import { useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/img/odu-yatay.png'


//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//API
import getToken from '../../services/getToken';
import verifyToken from '../../services/verifyToken';



const Login = () => {

    let navigate = useNavigate();

    const [eposta, setEposta] = useState("")
    const [sifre, setSifre] = useState("")


    const handleFormControl = () => {

        if(eposta===""){
            return toast.error("E-Posta adresinizi giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }else{
            const epostakontrol = eposta.toLocaleLowerCase('TR').endsWith("odu.edu.tr")
            if(!epostakontrol){
                return toast.error("Geçerli bir e-posta adresi giriniz", {
                    position: toast.POSITION.TOP_LEFT
                });
            }
        }

        if(sifre===""){
            return toast.error("Şifrenizi adresinizi giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        handleFormSubmit()
    }


    const handleFormSubmit = async () => {
        //Local storage te token var mı?
        const AUTH_TOKEN = localStorage.getItem('accessToken');

        if(!AUTH_TOKEN){
            //Token yok token al
            const new_token = await getToken(eposta, sifre)
            console.log(new_token)
            if(new_token.status === 200){
                //token alındı local storage kaydet
                localStorage.setItem('accessToken', new_token.data.accessToken)
                localStorage.setItem('adsoyad', new_token.data.AdSoyad)
                localStorage.setItem('role', new_token.data.role)
                navigate('/sedmin/dashboard')            
            }else{
                return toast.error("Bilgilerinizi kotrol edip tekar deneyiniz", {
                    position: toast.POSITION.TOP_LEFT
                });
            }
        }else{
            //Token var geçerliliğini kotrol et
            verifyTokenCheck()
        }
    }

    const verifyTokenCheck = async () =>{
        const token = await verifyToken(localStorage.getItem('accessToken'))
        if(token.status === 200){
            //token geçerli
            navigate('/sedmin/dashboard')
        }else{
            localStorage.removeItem('accessToken')
        }
    } 

    useEffect(() => {
        verifyTokenCheck()
        document.title = "Etik Kurul Kullanıcı Girişi"
        //eslint-disable-next-line
    }, []);

    

    return (
        <>
            <ToastContainer />
            <div className='relative mx-auto w-full max-w-sm bg-white'>
                <div>
                    <img src={logo} alt='Ordu Üniversitesi' className='h-16' />
                    <h2 className="text-2xl font-semibold  leading-6 mt-6 mb-2 text-slate-700"> Merhaba, </h2>
                    <p className="leading-6 text-sm text-slate-400 mb-6"> Eğitim Araştırmaları Etik Kurulu yetkili kullanıcı giriş ekranı</p>
                </div>
                <div className='mt-5'>
                    <div className='space-y-6'>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-400'>E-Posta adresiniz</label>
                            </div>
                            <div>
                                <div>
                                    <input onChange={(e)=>setEposta(e.target.value)} type='text' placeholder='Kurumsal e-posta adresiniz' className='text-slate-600 h-12 text-sm leading-5 px-4 py-1 w-full rounded-md border border-slate-300 focus:outline-slate-300 focus:outline-offset-2 focus:outline-dashed focus:outline-1' />
                                </div>
                                {/* <span className='text-slate-400 text-xs'>@odu.edu.tr yazmayınız</span> */}
                            </div>
                        </div>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-400'>Şifreniz</label>
                            </div>
                            <div>
                                <div>
                                    <input onChange={(e)=>setSifre(e.target.value)} type='password' placeholder='Kurumsal e-posta adresiniz' className='text-slate-600 h-12 text-sm leading-5 px-4 py-1 w-full rounded-md border border-slate-300 focus:outline-slate-300 focus:outline-offset-2 focus:outline-dashed focus:outline-1' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4 flex items-center justify-between'>
                        {/* <div>
                            <a href='?' className='text-slate-600 font-semibold text-xs hover:underline'>Hesabınız yok mu?</a>
                        </div> */}
                        <div>
                            <a href='https://personelsifre.odu.edu.tr/' target='blank' className='text-slate-600 font-semibold text-xs hover:underline'>Şifremi Unuttum!</a>
                        </div>
                    </div>
                    <div className='mt-6'>
                        <button onClick={handleFormControl} className='text-white bg-slate-600 hover:bg-slate-600/80 h-12 leading-5 px-4 py-1 w-full rounded-md border border-slate-300 focus:outline-slate-300 focus:outline-offset-2 focus:outline-dashed focus:outline-1 transition-all duration-150'>Giriş</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;
